export const FULLLINK = 'fulllink';
